import React, { FC } from 'react';

import { SectionTwoColumns } from '@/components/organisms/SectionTwoColumns/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const SectionFaq: FC<SectionTwoColumnsProps> & BlockConfigs = (
	props
) => {
	return <SectionTwoColumns {...props} />;
};

SectionFaq.slug = block.slug;
SectionFaq.title = block.title;
